export const REQUEST_BASE_URL = '/request/privilegedAccess';
export const JITA_REQUEST_BASE_URL = '/request/jitAccess';

// UX Design Breakpoints and Naming Structure (guide only do not edit):
// Mobile:
// 360px: 140 MobileXSmall (This is below our minimum, but it’s a common Android size, adding it here just in case)
// 375px: 130 MobileSmall
// 480px: 120 MobileLarge
// 600px: 110 MobileXLarge

// Tablet:
// 768px: 100 TabletXSmall
// 834px: 90 TabletSmall
// 900px: 80 TabletMedium
// 960px: 70 TabletLarge
// 1024px: 60 TabletXLarge

// Desktop:
// 1280px: 50 DesktopSmall
// 1366px: 40 DesktopMedium
// 1440px: 30 DesktopLarge
// 1600px: 20 DesktopXLarge
// 1920px: 10 DesktopXXLarge

// Screen descriptions
export const SCREEN_SIZE_MOBILE_XLARGE = 'MobileXLarge';
export const SCREEN_SIZE_TABLET_SMALL = 'TabletSmall';

// Add to these SCREEN_WIDTH_QUERIES as needed for certs responsivness
export const SCREEN_WIDTH_QUERIES = [
  { query: '(max-width: 599px)', value: 110, label: SCREEN_SIZE_MOBILE_XLARGE },
  { query: '(max-width: 833px)', value: 90, label: SCREEN_SIZE_TABLET_SMALL },
];
